<template>
  <div ref="rightBlock" class="right_block" :style="{ top: customerId == 42 ? '210px' : '150px' }"
    :class="{ isThinStyle: isThin }">
    <template v-if="styleType === 'typeGreen'">
      <div :style="getMultiComponentsBG(pathName)"></div>
    </template>
    <template v-if="styleType === 'typeStrong'">
      <div :style="getStrongBG(pathName)"></div>
    </template>
    <template v-if="styleType === 'typeBlue'">
      <div :style="getTypeBlueBG()"></div>
    </template>
    <template v-for="(item, n) in blockList" v-bind:key="n">
      <div :style="getStyle(item, n)"></div>
    </template>
    <template v-for="(obj, x) in rightMatrix" v-bind:key="x">
      <template v-for="(obj_, y) in obj" v-bind:key="y">
        <template v-if="obj_ && obj_.componentKey && isValidComponents(obj_.componentKey)">
          <div v-if="styleType === 'typeDark'" :class="getComponentStatus(x, y)" :style="componentsBlurBgStyle(obj_)">
          </div>
          <div :class="getComponentStatus(x, y, obj_.componentKey)" :style="componentsBgStyle(obj_)"></div>
          <div :class="getComponentStatus(x, y, obj_.componentKey)" :style="componentsStyle(obj_)"
            :id="'robot' + obj_.componentKey">
            <template v-if="obj_.componentKey == '11_1'">
              <div>11_1</div>
            </template>
            <template v-else-if="obj_.componentKey == '11_2'">
              <div>11_2</div>
            </template>
            <template v-else-if="obj_.componentKey == '13_1'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">重点监控点</span>
              </titleMod>
              <shed-list :matrix="'1*3'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '13_2'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">PM气泡列表</span>
              </titleMod>
              <pm-list :matrix="'1*3'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_1'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">厂区环境变化趋势</span>
              </titleMod>
              <trend-new :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_2'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">无组织治理控制</span>
              </titleMod>
              <clean-new :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_3'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">排放源清单管理</span>
              </titleMod>
              <emission-new :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                @click="openEmissionList()" :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_4'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">实时环境数据</span>
              </titleMod>
              <situation-new :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_5'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">无组织控制记录</span>
              </titleMod>
              <record-new :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_6'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">企业简介</span>
              </titleMod>
              <introduction-new :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0"
                @componentInit="componentInit" :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_7'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">运输车辆进出厂统计</span>
              </titleMod>
              <truck-statistics :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0"
                @componentInit="componentInit" :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_8'">
              <titleMod :iconType="obj_.componentKey">
                <span v-if="$store.state.customerId != 66" class="components_title">洗车机动态</span>
                <span v-else class="components_title">洗车台动态</span>
              </titleMod>
              <wash-car :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_9'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">脱硫脱硝监测数据</span>
              </titleMod>
              <desulphurization :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0"
                @componentInit="componentInit" :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_10'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">重点区域监控</span>
              </titleMod>
              <keyAreaMonitor :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_11'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">皮带通廊监控</span>
              </titleMod>
              <beltMonitor :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_12'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">全厂设备管理</span>
              </titleMod>
              <deviceManage :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_13'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">设备运行时长统计</span>
              </titleMod>
              <equipOpenTime :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_14'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">厂区道路监控</span>
              </titleMod>
              <roadMonitor :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_15'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">清扫车调度</span>
              </titleMod>
              <sweeper :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_16'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">告警类型排行</span>
              </titleMod>
              <warnRanking :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_17'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">闭环管理处理</span>
              </titleMod>
              <workOrder :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_18'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">设备启停次数统计</span>
              </titleMod>
              <equipOpenCount :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_19'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">有组织排放量统计</span>
              </titleMod>
              <equipEmission :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_20'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">碳排放监控点位</span>
              </titleMod>
              <monitorPoints :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_21'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">碳排放量分项管理（吨CO₂）</span>
              </titleMod>
              <manage :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" openModal="true" />
            </template>
            <template v-else-if="obj_.componentKey == '21_22'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">气象数据</span>
              </titleMod>
              <meteorologicalData :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0"
                @componentInit="componentInit" :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_23'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">道路清洁</span>
              </titleMod>
              <roadClean :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_24'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">碳生产率（元/吨CO₂）</span>
              </titleMod>
              <productivity :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_25'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">排放源清单管理</span>
              </titleMod>
              <emissionSourceNew @click="openEmissionList()" :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0"
                @componentInit="componentInit" :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_26'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">全厂数据监控系统</span>
              </titleMod>
              <dataMonitor :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_27'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">无组织治理控制</span>
              </titleMod>
              <unorganizedGovernance :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0"
                @componentInit="componentInit" :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_28'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">重点设备生产监控</span>
              </titleMod>
              <ieProductionMonitoring :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0"
                @componentInit="componentInit" :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_29'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">治理设备运行时长</span>
              </titleMod>
              <meRunningTime :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_30'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">无组织监控数据</span>
              </titleMod>
              <uMonitoringData :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0"
                @componentInit="componentInit" :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_31'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">有组织监控数据</span>
              </titleMod>
              <oMonitoringData :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0"
                @componentInit="componentInit" :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_32'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">数字孪生环保料场</span>
              </titleMod>
              <mathStockyard :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_33'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">闭环管理监控系统</span>
              </titleMod>
              <closeLoopMointor :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0"
                @componentInit="componentInit" :style="getTransform(x, y)" />
            </template>

            <template v-else-if="obj_.componentKey == '21_34'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">重点区域监控</span>
              </titleMod>
              <keyAreaMonitorNew :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0"
                @componentInit="componentInit" :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_35'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">减污降碳协同效果</span>
              </titleMod>
              <synergisticEffect :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0"
                @click="reduceEffect()"
                @componentInit="componentInit" :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_36'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">CEMS设备超标预测</span>
              </titleMod>
              <cemsPreAlarm :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_37'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">实时环境数据</span>
              </titleMod>
              <situation-new2 :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_38'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">实时环境数据</span>
              </titleMod>
              <situation-new3 :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_43'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">无组织控制记录</span>
              </titleMod>
              <record-new-2 :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '21_44'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">实时环境数据</span>
              </titleMod>
              <situation-new4 :matrix="'2*1'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '22_1'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">料棚全景监控</span>
              </titleMod>
              <shed-monitor :matrix="'2*2'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '22_2'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">智能识别告警</span>
              </titleMod>
              <intelligent-alarm :matrix="'2*2'" :x="x" :y="y" style="transform-origin: 0 0"
                @componentInit="componentInit" :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '22_3'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">料棚全景监控</span>
              </titleMod>
              <shed-monitor-new :matrix="'2*2'" :x="x" :y="y" style="transform-origin: 0 0"
                @componentInit="componentInit" :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '22_4'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">碳排放总览</span>
              </titleMod>
              <quota :matrix="'2*2'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '22_5'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">{{ isVisit ? '年度降碳水平' : '年度减污降碳水平' }}</span>
              </titleMod>
              <reduceCarbon :matrix="'2*2'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '22_6'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">道路视频监控</span>
              </titleMod>
              <mathRoadMonitor :matrix="'2*2'" :x="x" :y="y" style="transform-origin: 0 0"
                @componentInit="componentInit" :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '22_7'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">工序碳排放</span>
              </titleMod>
              <procedure2 :matrix="'2*2'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '22_8'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">碳中和实施进展（万吨）</span>
              </titleMod>
              <lcprogress :matrix="'2*2'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '23_1'">
              <!-- <span class="components_title">cems环保指标公示</span> -->
              <div class="changeType" @click="changeTypeTiny(x, y, obj_, obj_.componentKey)">切换列表</div>
              <cemsPublicityTiny id="cemsPublicityTiny" :matrix="'2*3'" :x="x" :y="y" style="transform-origin: 0 0"
                @componentInit="componentInit" :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '23_2'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title" v-if="customerId != 86 && customerId != 7">值守事件统计</span>
                <span class="components_title" v-else>闭环管理事件统计</span>
              </titleMod>
              <dutyStaticsListTiny id="dutyStaticsListTiny" :matrix="'2*3'" :x="x" :y="y" style="transform-origin: 0 0"
                @componentInit="componentInit" :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '23_3'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">有组织重点监控视频</span>
              </titleMod>
              <organizedKeyVideoTiny id="organizedKeyVideoTiny" :matrix="'2*3'" :x="x" :y="y"
                style="transform-origin: 0 0" @componentInit="componentInit" :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '23_4'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">工序碳排放</span>
              </titleMod>
              <procedure :matrix="'2*3'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '23_5'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">碳中和实施进展（万吨）</span>
              </titleMod>
              <lcprogress :matrix="'2*3'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '23_6'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">环保道路清单</span>
              </titleMod>
              <envProRoadList :matrix="'2*3'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '23_7'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">智能决策告警</span>
              </titleMod>
              <intelligentDecision :matrix="'2*3'" :x="x" :y="y" style="transform-origin: 0 0"
                @componentInit="componentInit" :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '23_9'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">排放源上下游关联</span>
              </titleMod>
              <emissionSourceList id="emissionSourceList" :matrix="'2*3'" :x="x" :y="y" style="transform-origin: 0 0"
                @componentInit="componentInit" :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '23_10'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">PM气泡列表</span>
              </titleMod>
              <pm-list-large :matrix="'2*3'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '23_11'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">碳中和实施进展（万吨）</span>
              </titleMod>
              <lcprogress89 :matrix="'2*3'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '23_12'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">污染预测及辅助决策</span>
              </titleMod>
              <pollutionPrediction :matrix="'2*3'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <!-- <template v-else-if="obj_.componentKey == '23_12'">
                            <titleMod :iconType="obj_.componentKey">
                                <span class="components_title">污染预测及辅助决策</span>
                              </titleMod>
                           
              <pollutionPrediction                 :matrix="'2*3'"                 :x="x"                 :y="y"        
                        style="transform-origin: 0 0"                 @componentInit="componentInit"                
                :style="getTransform(x, y)"               />
                         
            </template> -->
            <template v-else-if="obj_.componentKey == '31_1'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">脱硫脱硝除尘系统实时监控</span>
              </titleMod>
              <desulDenitrification :matrix="'3*1'" :x="x" :y="y" style="transform-origin: 0 0"
                @componentInit="componentInit" :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '31_2'">
              <div class="changeType" @click="changeTypeTiny(x, y, obj_, obj_.componentKey)">切换列表</div>
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">
                  除尘系统颗粒物实时监控
                  <span>(超低限值10mg/m³)</span>
                </span>
              </titleMod>
              <pmMonitor :matrix="'3*1'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '31_3'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">污水处理厂实时监控</span>
              </titleMod>
              <sewageDeal :matrix="'3*1'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '33_1'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">全厂事件统计</span>
              </titleMod>
              <factory-statistics :matrix="'3*3'" :x="x" :y="y" style="transform-origin: 0 0"
                @componentInit="componentInit" :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '33_2'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">排放源清单管理</span>
                <a @click="openEmissionList()" href="javascript:void(0)" class="allListBtn">清单总览</a>
              </titleMod>
              <unorganized-list :matrix="'3*3'" :x="x" :y="y" style="transform-origin: 0 0"
                @componentInit="componentInit" :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '33_3'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">有组织CEMS监控数据</span>
              </titleMod>
              <!-- <span class="components_title">cems环保指标公示</span>  -->
              <div class="changeType" @click="changeTypeTiny(x, y, obj_, obj_.componentKey)">切换公示</div>
              <cemsDataListTiny :matrix="'3*3'" :x="x" :y="y" style="transform-origin: 0 0"
                @componentInit="componentInit" :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '33_4'">
              <titleMod :iconType="obj_.componentKey">
                <span class="components_title">值守事件统计</span>
              </titleMod>
              <dutyStaticsList id="dutyStaticsList" :matrix="'3*3'" :x="x" :y="y" style="transform-origin: 0 0"
                @componentInit="componentInit" :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '33_5'">
              <qgThreeInOne id="dutyStaticsList" :matrix="'3*3'" :x="x" :y="y" style="transform-origin: 0 0"
                @componentInit="componentInit" :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '43_1'">
              <!-- <span class="components_title">cems环保指标公示</span> -->
              <div class="changeType" @click="changeTypeTiny(x, y, obj_, obj_.componentKey)">切换列表</div>
              <cemsPublicity id="cemsPublicity" :matrix="'4*3'" :x="x" :y="y" style="transform-origin: 0 0"
                @componentInit="componentInit" :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '43_2'">
              <!-- <div class="changeType" @click="changeTypeTiny(x, y, obj_, obj_.componentKey)">
                切换公示
              </div>-->
              <titleMod :iconType="obj_.componentKey">
                <span id="cemsDataList" class="components_title">有组织CEMS监控数据</span>
              </titleMod>
              <cemsDataList :matrix="'4*3'" :x="x" :y="y" style="transform-origin: 0 0" @componentInit="componentInit"
                :style="getTransform(x, y)" />
            </template>
            <template v-else-if="obj_.componentKey == '43_3'">
              <template v-if="!componentTiny">
                <titleMod :iconType="obj_.componentKey">
                  <span class="components_title">有组织重点监控视频</span>
                </titleMod>
                <organizedKeyVideo :matrix="'4*3'" :x="x" :y="y" style="transform-origin: 0 0"
                  @componentInit="componentInit" :style="getTransform(x, y)" />
              </template>
              <template v-else-if="componentTiny">
                <titleMod :iconType="obj_.componentKey">
                  <span class="components_title">有组织重点监控视频</span>
                </titleMod>
                <organizedKeyVideoTiny :matrix="'2*3'" :x="x" :y="y" style="transform-origin: 0 0"
                  @componentInit="componentInit" :style="getTransform(x, y)" />
              </template>
            </template>

          </div>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

import { mapState, mapGetters } from 'vuex'
//title
import titleMod from './components/componentsTools/titleMod/titleMod.vue'
//1_3
import shedList from './components/1_3/shedList/shed_list.vue'
import pmList from './components/1_3/PMList/pm_list.vue'
//2_1
import trendNew from './components/2_1/envirChangeTrend/trend_new.vue'
import emissionNew from './components/2_1/emissionSource/emission_new.vue'
import cleanNew from './components/2_1/cleanCar/clean_new.vue'
import situationNew from './components/2_1/AQIData/situation_new.vue'
import situationNew2 from './components/2_1/AQIData/situation_new2.vue'
import situationNew3 from './components/2_1/AQIData/situation_new3.vue'
import situationNew4 from './components/2_1/AQIData/situation_new4.vue'
import recordNew from './components/2_1/controlRecords/record_new.vue'
import recordNew2 from './components/2_1/controlRecords/record_new2.vue'
import introductionNew from './components/2_1/companyProfile/introduction_new.vue'
import truckStatistics from './components/2_1/truckStatistics/truckStatistics.vue'
import washCar from './components/2_1/washCar/washCar.vue'
import desulphurization from './components/2_1/desulphurization/desulphurization.vue'
import keyAreaMonitor from './components/2_1/keyAreaMonitor/keyAreaMonitor.vue'
import beltMonitor from './components/2_1/beltMonitor/beltMonitor.vue'
import deviceManage from './components/2_1/deviceManage/deviceManage.vue'
import equipOpenTime from './components/2_1/equipOpenTime/equipOpenTime.vue'
import equipOpenCount from './components/2_1/equipOpenCount/equipOpenCount.vue'
import equipEmission from './components/2_1/equipEmission/equipEmission.vue'
import roadMonitor from './components/2_1/roadMonitor/roadMonitor.vue'
import sweeper from './components/2_1/sweeper/sweeper.vue'
import warnRanking from './components/2_1/warnRanking/warnRanking.vue'
import workOrder from './components/2_1/workOrder/workOrder.vue'
import monitorPoints from './components/2_1/LC_monitorPoints/LC_monitorPoints.vue'
import manage from './components/2_1/LC_manage/LC_manage.vue'
import meteorologicalData from './components/2_1/MR_meteorologicalData/MR_meteorologicalData.vue'
import roadClean from './components/2_1/MR_roadClean/MR_roadClean.vue'
import productivity from './components/2_1/LC_productivity/LC_productivity.vue'
import keyAreaMonitorNew from './components/2_1/keyAreaMonitorNew/keyAreaMonitor.vue'
import meRunningTime from './components/2_1/ME_runningTime/ME_runningTime.vue'
import uMonitoringData from './components/2_1/U_monitoringData/U_monitoringData.vue'
import oMonitoringData from './components/2_1/O_monitoringData/O_monitoringData.vue'
import ieProductionMonitoring from './components/2_1/IE_productionMonitoring/IE_productionMonitoring.vue'
import emissionSourceNew from './components/2_1/emissionSourceNew/emissionSourceNew.vue'
import dataMonitor from './components/2_1/dataMonitor/dataMonitor.vue'
import unorganizedGovernance from './components/2_1/unorganizedGovernance/unorganizedGovernance.vue'
import mathStockyard from './components/2_1/mathStockyard/mathStockyard.vue'
import closeLoopMointor from './components/2_1/closeLoopMointor/closeLoopMointor.vue'
import synergisticEffect from './components/2_1/LC_synergisticEffect/LC_synergisticEffect.vue'
import cemsPreAlarm from './components/2_1/cemsPreAlarm'
//2_2
import shedMonitor from './components/2_2/shedMonitor/shedMonitor.vue'
import intelligentAlarm from './components/2_2/intelligentAlarm/intelligentAlarm.vue'
import shedMonitorNew from './components/2_2/shedMonitorNew/shedMonitorNew.vue'
import quota from './components/2_2/LC_quota/LC_quota.vue'
import reduceCarbon from './components/2_2/LC_reduceCarbon/LC_reduceCarbon.vue'
import mathRoadMonitor from './components/2_2/MR_roadMonitor/MR_roadMonitor.vue'
import procedure2 from './components/2_2/LC_procedure/LC_procedure.vue'
import lcprogress from './components/2_2/LC_progress/LC_progress.vue'

//2_3
import cemsPublicityTiny from './components/2_3/cemsPublicity/cemsPublicityTiny.vue'
import dutyStaticsListTiny from './components/2_3/dutyListTiny/dutyStaticsListTiny.vue'
import organizedKeyVideoTiny from './components/2_3/organizedKeyVideoTiny/index.vue'
import procedure from './components/2_3/LC_procedure/LC_procedure.vue'
import emissionSourceList from './components/2_3/emissionSourceList/emissionSourceList.vue'
import pmListLarge from './components/2_3/PMList_Large/pm_list.vue'
import pollutionPrediction from "./components/2_3/pollutionPrediction/pollutionPrediction.vue";

import envProRoadList from './components/2_3/MR_envProRoadList/MR_envProRoadList.vue'
import intelligentDecision from './components/2_3/BG_intelligentDecision/BG_intelligentDecision.vue'
import lcprogress89 from './components/2_3/LC_progress89/LC_progress89.vue'

//3_1
import sewageDeal from './components/3_1/sewageDeal/sewageDeal.vue'
import pmMonitor from './components/3_1/pmMonitor/pmMonitor.vue'
import desulDenitrification from './components/3_1/desulDenitrification/desulDenitrification.vue'

//3_3
import factoryStatistics from './components/3_3/factoryStatistics/factoryStatistics.vue'
import unorganizedList from './components/3_3/unorganizedList/unorganizedList.vue'
import cemsDataListTiny from './components/3_3/cemsDataList/cemsDataListTiny.vue'
import dutyStaticsList from './components/3_3/dutyList/dutyStaticsList.vue'
import qgThreeInOne from './components/3_3/qgThreeInOne/qgThreeInOne.vue'
// import emissionSource from "./components/3_3/emissionSource/emissionSource.vue";

//4_3
import cemsPublicity from './components/4_3/cemsPublicity/cemsPublicity.vue'
import cemsDataList from './components/4_3/cemsDataList/cemsDataList.vue'
import organizedKeyVideo from './components/4_3/organizedKeyVideo/index.vue'

import { storageGet } from '@/utils/tools.js'

import { unref } from 'vue'
import LowCarbonMod from '../../views/LowCarbonMod/LowCarbonMod.vue'
import { setPageActive } from "@/utils/platformmonitor.js";


export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'RightPart',
  inject: ['getBgCanvasData', 'getComponentsClose'],
  components: {
    shedList,
    trendNew,
    cleanNew,
    emissionNew,
    situationNew,
    situationNew2,
    situationNew3,
    situationNew4,
    recordNew,
    recordNew2,
    introductionNew,
    shedMonitor,
    shedMonitorNew,
    intelligentAlarm,
    truckStatistics,
    factoryStatistics,
    unorganizedList,
    washCar,
    desulphurization,
    cemsPublicity,
    cemsPublicityTiny,
    cemsDataList,
    cemsDataListTiny,
    keyAreaMonitor,
    titleMod,
    organizedKeyVideo,
    organizedKeyVideoTiny,
    beltMonitor,
    deviceManage,
    equipOpenTime,
    equipOpenCount,
    equipEmission,
    roadMonitor,
    dutyStaticsList,
    dutyStaticsListTiny,
    sweeper,
    warnRanking,
    workOrder,
    qgThreeInOne,
    sewageDeal,
    manage,
    quota,
    reduceCarbon,
    procedure,
    lcprogress,
    lcprogress89,
    pmMonitor,
    desulDenitrification,
    monitorPoints,
    meteorologicalData,
    envProRoadList,
    roadClean,
    mathRoadMonitor,
    procedure2,
    productivity,
    meRunningTime,
    uMonitoringData,
    oMonitoringData,
    ieProductionMonitoring,
    keyAreaMonitorNew,
    closeLoopMointor,
    emissionSourceNew,
    dataMonitor,
    unorganizedGovernance,
    mathStockyard,
    synergisticEffect,
    intelligentDecision,
    emissionSourceList,
    pmListLarge,
    cemsPreAlarm,
    pmList,
    pollutionPrediction
  },
  props: ['modelType'],

  data() {
    //这里存放数据
    return {
      unitH: 0,
      unitW: 0,
      Xnum: this.$store.state.leftPartX, //组件X轴块数
      Ynum: this.$store.state.leftPartY, //组件Y轴块数
      blockList: [], //组件块数
      rightMatrix: [],
      styleType: '',
      styleTypeMap: styleTypeMap,
      curBG: '',
      componentTiny: '',
      blurBG: '',
      // emissionSwitch: "",
      componentsClose: false,
      pathName: '',
      greenBG3_3: false,
      isThin: bmeConfig.isThin,
      asyncRenderTimer: {},
      rightMatrixValid: false,
      isBaoSteel: false,
    }
  },
  //计算属性 类似于data概念
  computed: {
    ...mapState({ emissionSwitch: 'emissionSwitch' }),
    ...mapState({ rightMatrix_store: 'rightPartMatrix' }),
    getMultiComponentsBG() {
      return pathName => {
        try {
          let nw = 2
          let componentsBg = '' //require("@/assets/img/components_bg/panelView_defaultBG_special.png");
          if (pathName === 'UnorganizedMod' || this.greenBG3_3) {
            let hasShedList = false
            for (let i = 0; i < this.rightMatrix.length; i++) {
              if (this.rightMatrix[i] && this.rightMatrix[i].length > 0) {
                for (let j = 0; j < this.rightMatrix[i].length; j++) {
                  let tmpObj = this.rightMatrix[i][j]
                  if (tmpObj.componentKey === '13_1') {
                    hasShedList = true
                    break
                  }
                }
              }
            }
            if (hasShedList) {
              componentsBg = require('@/assets/img/components_bg/panelView_defaultBG_special_3_3.png')
              nw = 3
            } else {
              componentsBg = require('@/assets/img/components_bg/panelView_defaultBG_special.png')
              nw = 2
            }
          } else if (pathName === 'DutyMod') {
            let hasDutyMod = false
            for (let i = 0; i < this.rightMatrix.length; i++) {
              if (this.rightMatrix[i] && this.rightMatrix[i].length > 0) {
                for (let j = 0; j < this.rightMatrix[i].length; j++) {
                  let tmpObj = this.rightMatrix[i][j]
                  if (tmpObj.componentKey === '23_2') {
                    hasDutyMod = true
                    break
                  }
                }
              }
            }
            if (hasDutyMod) {
              componentsBg = require('@/assets/img/components_bg/panelView_defaultBG_special.png')
              nw = 2
            } else {
              componentsBg = ''
              nw = 2
            }
          } else if (pathName === 'OrganizedMod' && window.bmeConfig.hideVideoWall) {
            console.log('rightMatrix', this.rightMatrix)
            let isFlag = false
            this.rightMatrix.forEach((item, i) => {
              item.forEach(item_ => {
                if (item_.componentKey) {
                  isFlag = true
                }
              })
            })
            componentsBg = isFlag ? require('@/assets/img/components_bg/panelView_defaultBG_special.png') : ''
            nw = 2
          } else {
            componentsBg = require('@/assets/img/components_bg/panelView_defaultBG_special.png')
            if (bmeConfig.isNewCarbon) {
              nw = 4
            } else {
              nw = 2

            }
          }
          let bg_url = 'url(' + componentsBg + ')'
          let deltaX = 20
          let deltaY = 20

          return {
            position: 'absolute',
            top: -1 * deltaY + 'px',
            right: -1 * deltaX + 'px',
            width: this.unitW * nw + deltaX * 2 + 'px',
            height: this.unitH * 3 + deltaY * 2 + 'px',
            background: bg_url,
            backgroundRepeat: 'no-repeat',
            backgroundSize: '100% 100%'
          }
        } catch (err) {
          console.log(err)
        }
      }
    },
    getStrongBG() {
      return pathName => {
        try {
          let nw = 2
          let componentsBg = '' //require("@/assets/img/components_bg/panelView_defaultBG_special.png");
          if (pathName === 'UnorganizedMod') {
            let hasShedList = false
            for (let i = 0; i < this.rightMatrix.length; i++) {
              if (this.rightMatrix[i] && this.rightMatrix[i].length > 0) {
                for (let j = 0; j < this.rightMatrix[i].length; j++) {
                  let tmpObj = this.rightMatrix[i][j]
                  if (tmpObj.componentKey === '13_1') {
                    hasShedList = true
                    break
                  }
                }
              }
            }
            if (hasShedList) {
              componentsBg = require('@/assets/img/components_bg/panelView_defaultBG_special_strong_3_3.png')
              nw = 3
            } else {
              componentsBg = require('@/assets/img/components_bg/panelView_defaultBG_special_strong.png')
              nw = 2
            }
          } else if (pathName === 'DutyMod') {
            let hasDutyMod = false
            for (let i = 0; i < this.rightMatrix.length; i++) {
              if (this.rightMatrix[i] && this.rightMatrix[i].length > 0) {
                for (let j = 0; j < this.rightMatrix[i].length; j++) {
                  let tmpObj = this.rightMatrix[i][j]
                  if (tmpObj.componentKey === '23_2') {
                    hasDutyMod = true
                    break
                  }
                }
              }
            }
            if (hasDutyMod) {
              componentsBg = require('@/assets/img/components_bg/panelView_defaultBG_special_strong.png')
              nw = 2
            } else {
              componentsBg = ''
              nw = 2
            }
          } else if (pathName === 'OrganizedMod' && window.bmeConfig.hideVideoWall) {
            console.log('rightMatrix', this.rightMatrix)
            let isFlag = false
            this.rightMatrix.forEach((item, i) => {
              item.forEach(item_ => {
                if (item_.componentKey) {
                  isFlag = true
                }
              })
            })
            componentsBg = isFlag ? require('@/assets/img/components_bg/panelView_defaultBG_special_strong.png') : ''
            nw = 2
          } else {
            componentsBg = require('@/assets/img/components_bg/panelView_defaultBG_special_strong.png')
            nw = 2
          }
          let bg_url = 'url(' + componentsBg + ')'
          let deltaX = 20
          let deltaY = 20
          if (this.curBG == 'typeStrong' && this.styleTypeMap[this.curBG].strongType == 1) {
            bg_url = ''
          }
          return {
            position: 'absolute',
            top: -1 * deltaY + 'px',
            right: -1 * deltaX + 'px',
            width: this.unitW * nw + deltaX * 2 + 'px',
            height: this.unitH * 3 + deltaY * 2 + 'px',
            background: bg_url,
            backgroundRepeat: 'no-repeat',
            backgroundSize: '100% 100%'
          }
        } catch (err) {
          console.log(err)
        }
      }
    },
    getTypeBlueBG() {
      return () => {
        let componentsBg = ''
        componentsBg = require('@/assets/img/components_bg/panelView_blueBg_2_3_wx.png')
        let bg_url = 'url(' + componentsBg + ')'
        let deltaX = 55
        let deltaY = 70
        try {
          return {
            position: 'absolute',
            top: -1 * deltaY + 'px',
            right: -1 * deltaX + 'px',
            width: this.unitW * 2 + deltaX * 2 + 'px',
            height: this.unitH * 3 + deltaY * 2 + 'px',
            background: bg_url,
            backgroundRepeat: 'no-repeat',
            backgroundSize: '100% 100%'
          }
        } catch (err) {
          console.log(err)
        }
      }
    },
    getComponentStatus() {
      // 判断方式存疑
      return (x, y, objKey) => {
        return {
          absolute: true,
          componentsClose: x > 1 || (objKey && objKey == '13_1') ? false : this.componentsClose
        }
      }
    },
    getStyle() {
      return (item, n) => {
        try {
          let left = (n % this.Xnum) * this.unitW
          let top = Math.floor(n / this.Xnum) * this.unitH
          return {
            position: 'absolute',
            left: left + 'px',
            top: top + 'px',
            //background: "green",
            opacity: 0.5,
            width: this.unitW + 'px',
            height: this.unitH + 'px'
            //border: "1px solid #000",
          }
        } catch (err) {
          return {}
        }
      }
    },
    isValidComponents() {
      return componentKey => {
        try {
          let result = true
          let componentKeyTags = componentKey.split('_')
          if (componentKeyTags.length > 1 && componentKeyTags[1] === '0') {
            result = false
          } else if (!componentKey) {
            result = false
          }

          if (bmeConfig.moduleSel && $.inArray(componentKey, window.assembly) >= 0) {
            result = false
          }
          return result
        } catch (err) {
          return {}
        }
      }
    },
    getTransform() {
      return (x, y) => {
        try {
          let obj_ = this.rightMatrix[x][y]
          return {
            position: 'absolute',
            top: 0,
            left: 0,
            padding: '20px',
            margin: '3px'
            //暂时注释掉组件自动缩放功能
            // transform: "scale(" + (obj_.scaleVal ? obj_.scaleVal : "1") + ")",
            // top: parseInt(obj_.marginTopVal) + "px",
            // // bottom:"5px",
            // left: parseInt(obj_.marginLeftVal) + "px",
            // width: parseInt(obj_.realWidth) + "px",
            // height: parseInt(obj_.realHeight) + "px",
            // position: "relative",
          }
        } catch (err) {
          return {}
        }
      }
    },
    componentsBlurBgStyle() {
      return item => {
        let imgH, imgW
        let bg_url = 'url(' + this.blurBG + ')'
        if (item.key == '0#0@1#0') {
          imgH = 1
          imgW = 2
        } else if (item.key == '0#0@0#1@0#2') {
          imgH = 3
          imgW = 1
        } else if (item.key == '0#0@1#0@2#0') {
          imgH = 1
          imgW = 3
        } else if (item.key == '0#0') {
          imgH = 1
          imgW = 1
        } else if (item.key == '0#0@0#1') {
          imgH = 2
          imgW = 1
        } else if (item.key == '0#0@1#0@0#1@1#1') {
          imgH = 2
          imgW = 2
        } else if (item.key == '0#0@1#0@2#0@0#1@1#1@2#1') {
          imgH = 2
          imgW = 3
        } else if (item.key == '0#0@1#0@0#1@1#1@0#2@1#2') {
          imgH = 3
          imgW = 2
        } else if (item.key == '0#0@1#0@2#0@0#1@1#1@2#1@0#2@1#2@2#2') {
          imgH = 3
          imgW = 3
        } else if (item.key == '0#0@1#0@2#0@3#0@0#1@1#1@2#1@3#1@0#2@1#2@2#2@3#2') {
          imgH = 3
          imgW = 4
        }
        let deltaX = 0
        if (item.componentKey === '43_3' && this.componentTiny) {
          deltaX = 2
          imgW = 2
        }
        let hideX = 0
        if (this.pathName === 'UnorganizedMod') {
          hideX = 1
        }
        try {
          if (bmeConfig.noCapture) {
            return {
              top: item.y * this.unitH + bmeConfig.borderH + 'px',
              left: (item.x + deltaX) * this.unitW + bmeConfig.borderW + 'px',
              width: imgW * this.unitW - bmeConfig.borderW * 2 + 'px',
              height: imgH * this.unitH - bmeConfig.borderH * 2 + 'px',
              /*backgroundImage: bg_url,*/
              backgroundSize: bmeConfig.INIT_WIDTH + 'px' + ' ' + bmeConfig.INIT_HEIGHT + 'px',
              /*filter: 'blur(10px)',*/
              backgroundColor: typeof (bmeConfig.noCapture) == "string" ? bmeConfig.noCapture : 'none',
              //opacity: 0.5,
              //backgroundPositionX: item.x * this.unitW + bmeConfig.borderW + "px",
              //backgroundPositionY: item.y * this.unitH + bmeConfig.borderH + "px",
              backgroundRepeat: 'no-repeat',
              /*backgroundAttachment: 'fixed',*/
              zIndex: -2,
              //display: item.componentKey === "43_1" ? "none" : "",
              display: this.componentTiny && item.x + deltaX <= 1 - hideX ? 'none' : ''
            }
          } else {
            return {
              top: item.y * this.unitH + bmeConfig.borderH + 'px',
              left: (item.x + deltaX) * this.unitW + bmeConfig.borderW + 'px',
              width: imgW * this.unitW - bmeConfig.borderW * 2 + 'px',
              height: imgH * this.unitH - bmeConfig.borderH * 2 + 'px',
              backgroundImage: bg_url,
              backgroundSize: bmeConfig.INIT_WIDTH + 'px' + ' ' + bmeConfig.INIT_HEIGHT + 'px',
              filter: 'blur(10px)',
              //opacity: 0.5,
              //backgroundPositionX: item.x * this.unitW + bmeConfig.borderW + "px",
              //backgroundPositionY: item.y * this.unitH + bmeConfig.borderH + "px",
              backgroundRepeat: 'no-repeat',
              backgroundAttachment: 'fixed',
              zIndex: -2,
              display: this.componentTiny && item.x + deltaX <= 1 - hideX ? 'none' : ''
            }
          }
        } catch (err) {
          // console.log(err);
          return {}
        }
      }
    },
    componentsBgStyle() {
      return item => {
        let imgH, imgW
        let bg_url
        if (item.key == '0#0@1#0') {
          imgH = 1
          imgW = 2
        } else if (item.key == '0#0@0#1@0#2') {
          imgH = 3
          imgW = 1
        } else if (item.key == '0#0@1#0@2#0') {
          imgH = 1
          imgW = 3
        } else if (item.key == '0#0') {
          imgH = 1
          imgW = 1
        } else if (item.key == '0#0@0#1') {
          imgH = 2
          imgW = 1
        } else if (item.key == '0#0@1#0@0#1@1#1') {
          imgH = 2
          imgW = 2
        } else if (item.key == '0#0@1#0@2#0@0#1@1#1@2#1') {
          imgH = 2
          imgW = 3
        } else if (item.key == '0#0@1#0@0#1@1#1@0#2@1#2') {
          imgH = 3
          imgW = 2
        } else if (item.key == '0#0@1#0@2#0@0#1@1#1@2#1@0#2@1#2@2#2') {
          imgH = 3
          imgW = 3
        } else if (item.key == '0#0@1#0@2#0@3#0@0#1@1#1@2#1@3#1@0#2@1#2@2#2@3#2') {
          imgH = 3
          imgW = 4
        }
        let deltaX = 0
        if (item.componentKey === '43_3' && this.componentTiny) {
          deltaX = 2
          imgW = 2
        }
        let hideX = 0
        if (this.pathName === 'UnorganizedMod') {
          hideX = 1
        }
        try {
          let bg_name = this.styleTypeMap[this.curBG].bgImg
          if (this.curBG == 'typeStrong' && this.styleTypeMap[this.curBG].strongType == 2) {
            bg_name = this.styleTypeMap[this.curBG].bgImg + '_Bg'
          }
          let componentsBg = require('@/assets/img/components_bg/' +
            (this.isBaoSteel ? 'panelView_baoSteel' : bg_name) +
            '_' +
            imgW +
            '_' +
            imgH +
            '.png')
          bg_url = 'url(' + componentsBg + ')'
          if (this.styleType == 'typeBlue' || item.componentKey == '43_1' || item.componentKey == '23_1') {
            bg_url = 'none'
          }
          if (this.styleType == 'typeStrong' && this.customerId == 89) {
            let componentsBg_89 = require('@/assets/img/components_bg/' +
              (this.isBaoSteel ? 'panelView_baoSteel' : 'panelView_strong_Bg_89') +
              '_' +
              imgW +
              '_' +
              imgH +
              '.png')
            bg_url = 'url(' + componentsBg_89 + ')'
          }
          // if(styleType=='typeBlue') bg_url='none';
          return {
            top: item.y * this.unitH + bmeConfig.borderH + 'px',
            left: (item.x + deltaX) * this.unitW + bmeConfig.borderW + 'px',
            width: imgW * this.unitW - bmeConfig.borderW * 2 + 'px',
            height: imgH * this.unitH - bmeConfig.borderH * 2 + 'px',
            backgroundImage: bg_url,
            backgroundSize: '100% 100%',
            backgroundRepeat: 'no-repeat',
            display: this.componentTiny && item.x + deltaX <= 1 - hideX ? 'none' : '',
            opacity: this.customerId == 89 ? 0.75 : '',
            /*zIndex: this.isBaoSteel ? 99 : "",
            opacity: this.isBaoSteel ? 0.5 : 1,*/
          }
        } catch (err) {
          // console.log(err);
          return {}
        }
      }
    },
    componentsStyle() {
      return item => {
        let imgH, imgW
        let bg_url
        if (item.key == '0#0@1#0') {
          imgH = 1
          imgW = 2
        } else if (item.key == '0#0@0#1@0#2') {
          imgH = 3
          imgW = 1
        } else if (item.key == '0#0@1#0@2#0') {
          imgH = 1
          imgW = 3
        } else if (item.key == '0#0') {
          imgH = 1
          imgW = 1
        } else if (item.key == '0#0@0#1') {
          imgH = 2
          imgW = 1
        } else if (item.key == '0#0@1#0@0#1@1#1') {
          imgH = 2
          imgW = 2
        } else if (item.key == '0#0@1#0@0#1@1#1@0#2@1#2') {
          imgH = 3
          imgW = 2
        } else if (item.key == '0#0@1#0@2#0@0#1@1#1@2#1@0#2@1#2@2#2') {
          imgH = 3
          imgW = 3
        } else if (item.key == '0#0@1#0@2#0@3#0@0#1@1#1@2#1@3#1@0#2@1#2@2#2@3#2') {
          imgH = 3
          imgW = 4
        }
        let deltaX = 0
        if (item.componentKey === '43_3' && this.componentTiny) {
          deltaX = 2
          imgW = 2
        }
        let hideX = 0
        if (this.pathName === 'UnorganizedMod') {
          hideX = 1
        }
        try {
          return {
            top: item.y * this.unitH + bmeConfig.borderH + 'px',
            left: (item.x + deltaX) * this.unitW + bmeConfig.borderW + 'px',
            width: imgW * this.unitW - bmeConfig.borderW * 2 + 'px',
            height: imgH * this.unitH - bmeConfig.borderH * 2 + 'px',
            color: this.styleTypeMap[this.styleType].fontColor,
            padding: '20px',
            pointerEvents: 'all',
            display: this.componentTiny && item.x + deltaX <= 1 - hideX ? 'none' : '',
            background: this.darkStyle ? 'rgba(0,0,0,.3)' : 'none',
            overflow: this.curBG == 'typeStrong' && this.styleTypeMap[this.curBG].strongType == 1 ? 'hidden' : 'none'
            /*background: this.isBaoSteel
              ? "linear-gradient(90deg, #2d6bff, #004aff91, #2d6bff)"
              : "none",*/
          }
        } catch (err) {
          return {}
        }
      }
    },
    curBGVal() {
      return this.$store.state.curBG
    },
    curComponentTiny() {
      return this.$store.state.componentTiny
    },
    curStyleTypeVal() {
      return this.$store.state.styleType
    },
    isVisit() {
      return this.$store.state.isVisit
    }
  },
  //监控data中的数据变化
  watch: {
    rightMatrix_store: {
      handler(newVal, oldVal) {
        this.initFunc()
      },
      deep: true
    },
    '$route.name': {
      handler(newVal, oldVal) {
        this.pathName = newVal
      },
      deep: true
    },
    getBgCanvasData: {
      handler(newVal, oldVal) {
        this.blurBG = unref(newVal)
        this.$forceUpdate()
      },
      deep: true
    },
    curBGVal: {
      handler(newVal, oldVal) {
        this.curBG = newVal
        this.$forceUpdate()
      },
      deep: true
    },
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal
        this.componentTiny = this.$store.state.componentTiny
        this.typeChange()
      },
      deep: true
    },
    curComponentTiny: {
      handler(newVal, oldVal) {
        this.componentTiny = newVal
        this.initFunc()
      },
      deep: true
    },
    getComponentsClose: {
      handler(newVal, oldVal) {
        this.componentsClose = unref(newVal)
        this.$forceUpdate()
      },
      deep: true
    }
  },
  //方法集合
  methods: {
    openEmissionList() {
      this.$store.commit('changeEmissionSwitch', 'open')
    },
    changeTypeTiny(a, b, obj, key) {
      if (key == '23_1') {
        $('#cemsPublicityTiny').fadeOut(1000, () => {
          this.leftMatrix[a][b].componentKey = '33_3'
          this.leftMatrix[a][b].fromId = key
          this.leftMatrix[a][b].key = '0#0@1#0@2#0@0#1@1#1@2#1@0#2@1#2@2#2'
          this.$forceUpdate()
        })
      } else if (key == '43_1') {
        $('#cemsPublicity').fadeOut(1000, () => {
          this.leftMatrix[a][b].componentKey = '33_3'
          this.leftMatrix[a][b].fromId = key
          this.leftMatrix[a][b].key = '0#0@1#0@2#0@0#1@1#1@2#1@0#2@1#2@2#2'
          this.$forceUpdate()
        })
      } else if (key == '33_3') {
        $('#cemsDataListTiny').fadeOut(1000, () => {
          if (this.leftMatrix[a][b].fromId == '23_1') {
            this.leftMatrix[a][b].componentKey = '23_1'
            this.leftMatrix[a][b].key = '0#0@1#0@0#1@1#1@0#2@1#2'
          } else {
            this.leftMatrix[a][b].componentKey = '43_1'
            this.leftMatrix[a][b].key = '0#0@1#0@2#0@3#0@0#1@1#1@2#1@3#1@0#2@1#2@2#2@3#2'
          }
          this.$forceUpdate()
        })
      }
      this.$nextTick(() => {
        setTimeout(() => {
          this.typeChange()
        }, 2000)
      })
    },
    changeType(a, b, key) {
      if (key == '43_1') {
        $('#cemsPublicity').fadeOut(1000, () => {
          this.rightMatrix[a][b].componentKey = '33_3'
          this.rightMatrix[a][b].key = '0#0@1#0@0#1@1#1@0#2@1#2'
          this.$forceUpdate()
        })
      } else if (key == '33_3') {
        $('#cemsDataListTiny').fadeOut(1000, () => {
          if (this.rightMatrix[a][b].fromId == '23_1') {
            this.rightMatrix[a][b].componentKey = '23_1'
            this.rightMatrix[a][b].key = '0#0@1#0@0#1@1#1@0#2@1#2'
          } else {
            this.rightMatrix[a][b].componentKey = '43_1'
            this.rightMatrix[a][b].key = '0#0@1#0@2#0@3#0@0#1@1#1@2#1@3#1@0#2@1#2@2#2@3#2'
          }

          // this.$nextTick(()=>{
          //  $("#cemsPublicity").fadeIn(2000);
          // })
        })
      }
    },
    reduceEffect(){
      console.log('=================================')
      setPageActive("减污降碳协同效果", "open", 0)
    },
    componentScale(obj) {
      let scaleArr = obj.matrixType.split('*')
      //let val = scaleArr[0] / scaleArr[1];
      let width = obj.w
      let height = obj.h

      let scaleValue, marginTopVal, marginLeftVal, realWidth, realHeight

      let scaleWith = this.unitW * scaleArr[0] - 10
      let scaleHeight = this.unitH * scaleArr[1] - 10 - 20 + 20
      if (width / height > scaleWith / scaleHeight) {
        realWidth = scaleWith
        realHeight = (height / width) * realWidth
        scaleValue = realHeight / height
        marginLeftVal = scaleWith - realWidth
        marginTopVal = (scaleHeight - realHeight) / 2
        // console.log("X缩放比例是", scaleValue);
      } else {
        realHeight = scaleHeight
        realWidth = (width / height) * realHeight
        scaleValue = realWidth / width
        marginLeftVal = (scaleWith - realWidth) / 2
        marginTopVal = scaleHeight - realHeight
        // console.log("Y缩放比例是", scaleValue);
      }
      let x = obj.x
      let y = obj.y
      this.rightMatrix[x][y]['scaleVal'] = scaleValue
      this.rightMatrix[x][y]['marginTopVal'] = marginTopVal
      this.rightMatrix[x][y]['marginLeftVal'] = marginLeftVal
      this.$forceUpdate()
    },
    componentInit(obj) {
      this.componentScale(obj)
    },
    typeChange() {
      if (this.styleType == 'typeGreen') {
        this.$nextTick(() => {
          $('.home_tab').addClass('home_tab_green')
          $('.home_tab_actived').addClass('home_tab_actived_green')
        })
      } else if (this.styleType == 'typeDark') {
        this.$nextTick(() => {
          $('.home_tab').removeClass('home_tab_green')
          $('.home_tab_actived').removeClass('home_tab_actived_green')
        })
      }
    },
    initFunc() {
      this.unitH = bmeConfig.DIY_H
      this.unitW = bmeConfig.DIY_W
      this.Xnum = this.$store.state.rightPartX //组件X轴块数
      this.Ynum = this.$store.state.rightPartY //组件Y轴块数
      this.styleType = this.$store.state.styleType
      this.typeChange()
      this.styleTypeMap = styleTypeMap

      this.$refs.rightBlock.style.height = this.Ynum * this.unitH + 'px'
      this.$refs.rightBlock.style.width = this.Xnum * this.unitW + 'px'
      this.rightMatrix = this.rightMatrix_store[this.modelType]

      if (bmeConfig.rectType) {
        $(this.$refs.rightBlock).css('transform', 'scale(1.2)')
        $(this.$refs.rightBlock).css('transformOrigin', 'right top')
        $(this.$refs.rightBlock).css('top', '450px')
      }

      this.blockList = new Array(12)

      this.curBG = this.$store.state.curBG
      this.componentTiny = this.$store.state.componentTiny

      this.blurBG = ''

      if (this.modelType) {
        let storageKey = 'rightPartMatrix-' + this.modelType
        let obj = storageGet(storageKey)
        if (!$.isEmptyObject(obj)) {
          //this.rightMatrix = obj;
          /*if (!this.componentTiny) {
            this.rightMatrix = obj;
          } else {
            this.rightMatrix = [];
            for (var i = 0; i < 2; i++) {
              this.rightMatrix.push(obj[i]);
            }
          }*/
          let n = 0
          for (let i = 0; i < obj.length; i++) {
            let tmpObj = obj[i]
            for (let j = 0; j < tmpObj.length; j++) {
              if (tmpObj[j] && tmpObj[j]['componentKey']) {
                n++
                this.asyncRender(i, j, tmpObj[j], n)
              } else {
                this.asyncRender(i, j, tmpObj[j], 0)
              }
            }
          }
        }
      }

      this.blurBGTimer = setTimeout(() => {
        if (window.unityCanvasBG) {
          this.blurBG = window.unityCanvasBG
          this.$forceUpdate()
        }
      }, 2500)
      //this.$forceUpdate();
    },
    asyncRender(i, j, val, n) {
      let time = n * 50
      if (this.asyncRenderTimer[i + '_' + j]) {
        clearTimeout(this.asyncRenderTimer[i + '_' + j])
      }
      this.asyncRenderTimer[i + '_' + j] = setTimeout(() => {
        if (!this.rightMatrix) {
          this.rightMatrix = []
        }
        if ($.isEmptyObject(this.rightMatrix[i])) {
          this.rightMatrix[i] = []
        }
        this.rightMatrix[i][j] = val
        //this.$forceUpdate();
      }, 50)
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.pathName = this.$route.name
    this.componentTiny = this.$store.state.componentTiny
    this.unitH = bmeConfig.DIY_H
    this.unitW = bmeConfig.DIY_W
    this.styleType = bmeConfig.styleType
    this.darkStyle = bmeConfig.darkStyle
    this.customerId = parseInt(bmeConfig.customerSign)
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.isThin = bmeConfig.isThin

    this.isBaoSteel = bmeConfig.isBaoSteel

    this.rightMatrixValid = true

    let this_ = this
    if (this.styleType != 'typeBlue') {
      setTimeout(function () {
        $(this_.$refs.rightBlock).addClass('slider_in')
      }, 50)
    } else {
      setTimeout(function () {
        $('.right_block').css('right', '105px').css('top', '133px')
      }, 50)
    }

    this.initFunc()
  },
  beforeUnmount() {
    for (let i in this.asyncRenderTimer) {
      if (this.asyncRenderTimer[i]) {
        clearTimeout(this.asyncRenderTimer[i])
      }
    }
    if (this.blurBGTimer) {
      clearTimeout(this.blurBGTimer)
    }
  },
  activated() {
    if (window.unityCanvasBG) {
      this.blurBG = window.unityCanvasBG
    }
  }
}
</script>
<style lang="scss" scoped="scoped">
.componentsClose {
  transform: rotateY(180deg);
  transform-origin: right;
  opacity: 0;
  z-index: -5 !important;
}

.absolute {
  transition: all 1s linear;
}

.allListBtn {
  position: absolute;
  top: 10px;
  right: 50px;
  font-family: 'fontNormal';
  color: #4be0ff;
  font-size: 18px;
}

.slider_in {
  right: 45px !important;
}

.slider_out {
  right: -1600px !important;
}

.right_block {
  position: absolute;
  top: 150px;
  right: -1600px;
  transition: right 0.5s;
  -moz-transition: right 0.5s;
  /* Firefox 4 */
  -webkit-transition: right 0.5s;
  /* Safari and Chrome */
  -o-transition: right 0.5s;
  /* Opera */
  z-index: -1;
}

.typeGreen .components_title {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 10px;
}

.typeStrong .components_title {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 8px;
}

.typeStrong-89 .components_title {
  position: absolute;
  left: 3%;
}

.components_title {
  color: #e2effd;
  font-size: 20px;
  vertical-align: middle;
}

.changeType {
  position: absolute;
  width: 45px;
  height: 202px;
  background: #00ffa7;
  border-radius: 24px 20px 20px 24px;
  border: 1px solid #9fedff;
  font-size: 30px;
  font-weight: 500;
  color: #000000;
  line-height: 32px;
  cursor: pointer;
  pointer-events: all;
  line-height: 1.6;
  writing-mode: vertical-lr;
  text-align: center;
  z-index: 2;
  top: 50%;
  right: -16px;
  transform: translateY(-50%);
}

.isThinStyle {
  transform: scale(0.6);
  right: -230px !important;
}
</style>
